module.exports = __webpack_public_path__ + "static/media/Freedom Mile - Instrumental Version Cover Art.3447bcf1.jpg";